import {Routes} from '@angular/router';
import {LoginComponent} from './components/login/login.component';
import {HomeComponent} from './components/home/home.component';
import {PromptDetailComponent} from './components/prompts/prompt-detail/prompt-detail.component';
import {UserPageComponent} from './components/user/user-page/user-page.component';
import {PacksPageComponent} from './components/packs/packs-page/packs-page.component';
import {PromptsPageComponent} from './components/prompts/prompts-page/prompts-page.component';
import {PackDetailsPageComponent} from './components/packs/pack-details-page/pack-details-page.component';
import {MarketplacePageComponent} from './components/marketplace/marketplace-page/marketplace-page.component';
import {ProfileComponent} from './components/user/profile/profile.component';
import {OrganizationManagementComponent} from './components/organizations/organization-management/organization-management.component';
import {AuthGuard, redirectLoggedInToHome, redirectUnauthorizedToLogin} from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: UserPageComponent,
    canActivateChild: [AuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin},
    children: [
      {path: 'home', component: HomeComponent},
      {path: 'marketplace', component: MarketplacePageComponent},
      {path: 'prompts', component: PromptsPageComponent},
      {path: 'prompts/new', component: PromptDetailComponent},
      {path: 'prompts/:name', component: PromptDetailComponent},
      {path: 'packs', component: PacksPageComponent},
      {path: 'packs/new', component: PackDetailsPageComponent},
      {path: 'packs/:name', component: PackDetailsPageComponent},
      {path: 'profile', component: ProfileComponent},
      {path: 'api-keys', redirectTo: 'profile', pathMatch: 'full'},
      {path: 'organizations/:id', component: OrganizationManagementComponent},
      {path: '', pathMatch: 'full', redirectTo: 'home'},
    ]
  },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard], data: { authGuardPipe: redirectLoggedInToHome } },
  { path: '**', redirectTo: '/home' }
];
